import {Mapper} from '@s-ui/domain'

const FIRST_PAGE = 1

export class SeoTechnicalDetailsSearchMetaInformationMapper extends Mapper {
  constructor({
    config,
    searchRequestValueObjectFactory,
    seoDataValueObjectFactory,
    getUrlSearchService,
    seoDataMapper,
    seoLiteralMapper
  }) {
    super()

    this._config = config
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._getUrlSearchService = getUrlSearchService
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
  }

  _getUrls = async ({searchRequestObjectVO, pageName, page, totalPages}) => {
    const url = await this._getUrlSearchService.execute({
      search: searchRequestObjectVO,
      queryPlaceholder: {
        query: 'pg',
        placeholder: '%{pageNumber}'
      },
      pageName
    })

    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const pathName = url.getUrl()

    const [canonicalPathName] = pathName.split('?')

    return {
      canonical: `${protocol}${host}${canonicalPathName}`,
      next: this._getNextUrl({url: pathName, page, totalPages}),
      prev: this._getPrevUrl({url: pathName, page, totalPages})
    }
  }

  _getNextUrl = ({url, page, totalPages}) => {
    if (totalPages > page) {
      const nextPage = page + 1
      return url.replace('%{pageNumber}', nextPage)
    }
  }

  _getPrevUrl = ({url, page}) => {
    if (page > 1) {
      const prevPage = page - 1
      return url.replace('%{pageNumber}', prevPage)
    }
  }

  async map({culture, pageName, params = {}}) {
    const {page = FIRST_PAGE, totalPages, sortBy = this._defaultSortBy, sortOrder = this._defaultSortOrder} = params

    const {technicalDetails: technicalDetailsSearchConfig} = this._config.get('seo')
    const {TITLE, META_DESCRIPTION, META_ROBOTS} = technicalDetailsSearchConfig[pageName][culture]

    const searchRequestObjectVO = this._searchRequestValueObjectFactory({
      page,
      sortBy,
      sortOrder
    })

    const {canonical} = await this._getUrls({
      searchRequestObjectVO,
      pageName,
      page,
      totalPages
    })

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).map()

    const parsedDescription = this._seoLiteralMapper.setText({text: META_DESCRIPTION}).map()

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .robots(META_ROBOTS)
      .canonical(canonical)
      .setOpenGraphData({
        title: parsedTitle,
        description: parsedDescription,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
